import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Campaigns from "../pages/campaigns/page";
import CampaignDetail from "../pages/campaign-detail/page";
import Donate from "../pages/donate/page";
import Volunteer from "../pages/volunteer/page";
import StartFundraiser from "../pages/start-fundraiser/page";
import Impact from "../pages/impact/page";
import Gallery from "../pages/gallery/page";
import Blog from "../pages/blog/page";
import Contact from "../pages/contact/page";
import Admin from "../pages/admin/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/campaigns",
    element: <Campaigns />,
  },
  {
    path: "/campaigns/:id",
    element: <CampaignDetail />,
  },
  {
    path: "/donate",
    element: <Donate />,
  },
  {
    path: "/volunteer",
    element: <Volunteer />,
  },
  {
    path: "/start-fundraiser",
    element: <StartFundraiser />,
  },
  {
    path: "/impact",
    element: <Impact />,
  },
  {
    path: "/gallery",
    element: <Gallery />,
  },
  {
    path: "/blog",
    element: <Blog />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/admin",
    element: <Admin />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;